import { cn, StarIcon, StarOutlineIcon } from "@au-schein-de/au-ui-library";

const starSvgClass = "size-2.5 shrink-0";

type ProfileHubRatingStarsProps = {
	rating: number;
	ariaLabel: string;
	className?: string;
	/** `edit`: single filled star beside the saved score while changing a rating. `preview`: filled stars for the saved score. */
	variant?: "preview" | "edit";
};

export function ProfileHubRatingStars({
	rating,
	ariaLabel,
	className,
	variant = "preview",
}: ProfileHubRatingStarsProps) {
	if (variant === "edit") {
		return (
			<span
				role="img"
				aria-label={ariaLabel}
				className={cn("inline-flex items-center gap-1", className)}
			>
				<StarIcon.Raw
					key="profile-hub-rating-star-1"
					className={cn(starSvgClass, "text-gray-900")}
					aria-hidden
				/>
			</span>
		);
	}
	const fullStars = Math.max(0, Math.min(5, Math.floor(rating)));
	return (
		<span
			role="img"
			aria-label={ariaLabel}
			className={cn("inline-flex items-center gap-1", className)}
		>
			{Array.from({ length: 5 }, (_, index) => {
				const key = `profile-hub-rating-star-${index}`;
				if (index < fullStars) {
					return (
						<StarIcon.Raw
							key={key}
							className={cn(starSvgClass, "text-gray-900")}
							aria-hidden
						/>
					);
				}
				return (
					<StarOutlineIcon.Raw
						key={key}
						className={cn(starSvgClass, "text-gray-900")}
						aria-hidden
					/>
				);
			})}
		</span>
	);
}
